import type { SiteContent } from "./types.js";

const content: SiteContent = {
  meta: {
    title: "Kuori — o evento inteiro, por quem esteve nele",
    description:
      "O convidado entra pelo QR code, fotografa pelo navegador e as fotos vão para o álbum do evento e para o telão ao vivo. Sem instalar aplicativo.",
    whatsapp: "Oi! Vim pelo site da Kuori e queria saber mais.",
    photoAlt: {
      hero: "Convidados de braços erguidos na pista de dança, sob luz quente de festa",
      foot: "Fogos de artifício no fim da festa, vistos por trás dos convidados",
      brand: "Cartão de mesa com QR code sobre a mesa posta, à luz das velas",
    },
    shotAlt: {
      guest: "A câmera do evento aberta no telefone do convidado",
      organizer: "O painel do organizador com o resumo de um evento",
      telao: "O telão em tela cheia com as fotos reveladas do evento",
    },
  },
  nav: {
    language: "Idioma",
    sections: "Seções",
    menu: "Abrir o menu",
    close: "Fechar o menu",
    como: "Como funciona",
    produto: "Produto",
    precos: "Preços",
    faq: "Perguntas",
    cta: "Falar no WhatsApp",
    short: "Falar",
  },
  hero: {
    kicker: "Fotos de evento, capturadas pelos convidados",
    title: ["O evento inteiro,", "por quem ", "esteve nele"],
    sub: "O convidado entra pelo QR code, fotografa pelo navegador e as fotos vão para o álbum do evento e para o telão ao vivo. Sem instalar aplicativo.",
    cta: "Falar no WhatsApp",
    alt: "Ver como funciona",
  },
  facts: [
    ["Sem app", "O convidado abre a câmera no navegador, direto do QR code."],
    ["Ao vivo", "As fotos aparecem no álbum e no telão enquanto o evento acontece."],
    ["Sob controle", "Você modera, oculta e decide quando as fotos são reveladas."],
  ],
  how: {
    label: "Como funciona",
    title: "Três passos, nenhum download.",
    steps: [
      [
        "01",
        "Crie o evento",
        "Nome, data, quantos convidados e quando as fotos aparecem. Leva um minuto e sai com o QR pronto para imprimir.",
      ],
      [
        "02",
        "Espalhe o QR",
        "No convite, no cartão de mesa, no telão. Quem aponta a câmera entra na hora, pelo navegador.",
      ],
      [
        "03",
        "Receba o álbum",
        "As fotos chegam separadas por hora, com moderação e download em qualidade original.",
      ],
    ],
  },
  guest: {
    label: "O convidado",
    title: "Uma câmera que cabe em segundos.",
    body: "Abre, fotografa, volta para o evento. A câmera tem cota por pessoa, funciona dentro do WhatsApp e do Instagram, e não pede cadastro nem instalação.",
    bullets: [
      "Entra pelo QR code ou link",
      "Cota de fotos por pessoa",
      "Álbum do evento no mesmo lugar",
      "Funciona em 4G, sem app",
    ],
  },
  organizer: {
    label: "O organizador",
    title: "Um painel para todos os seus eventos.",
    body: "Crie, acompanhe e modere de qualquer lugar. Cada evento tem seu convite, seu álbum por hora, sua fila de moderação e seu telão.",
    bullets: [
      "Painel multi-evento",
      "Convite com QR e link curto",
      "Moderação e banimento",
      "Revelação na hora ou no fim",
    ],
  },
  panel: {
    label:
      "Ilustração do painel do organizador: a lista de eventos com um casamento ao vivo, dois eventos agendados e um aniversário encerrado",
    title: "Eventos",
    newEvent: "Novo evento",
    rail: ["Eventos", "Preferências"],
    groups: { live: "Ao vivo agora", upcoming: "Próximos", ended: "Encerrados" },
    status: { live: "Ao vivo", scheduled: "Agendado", ended: "Encerrado" },
    remaining: "41h",
    events: {
      wedding: {
        name: "Casamento Ana & Rafael",
        meta: "sáb, 19 set · 19h00 · 183 convidados · 1.247 mídias",
        short: "1.247 mídias",
      },
      graduation: {
        name: "Formatura Medicina 2026",
        meta: "sex, 2 out · 21h00 · Convidados 0/250",
        short: "sex, 2 out · 21h00",
      },
      company: {
        name: "Confraternização Vertex",
        meta: "sex, 11 dez · 20h00 · Convidados 0/100",
        short: "sex, 11 dez · 20h00",
      },
      birthday: {
        name: "Aniversário 30 · Beatriz",
        meta: "sáb, 22 ago · 38 convidados · 289 mídias",
        short: "289 mídias",
      },
    },
  },
  telao: {
    label: "Telão",
    title: "O evento se vendo acontecer.",
    body: "Uma página em tela cheia no projetor ou na TV. As fotos entram assim que são reveladas, com o nome de quem tirou, legíveis a metros de distância.",
  },
  brand: {
    label: "Marca branca",
    title: "Seu nome na frente, o nosso fora do caminho.",
    body: "Profissionais de eventos entregam a Kuori com o próprio nome, logotipo e cor. A interface é neutra de propósito: a cor da tela vem das fotos do evento, não da nossa marca.",
  },
  pricing: {
    label: "Preços",
    title: "Pagamento por evento. Sem assinatura.",
    sub: "Você escolhe a faixa pelo número de convidados esperado. Dá para subir de faixa depois pagando só a diferença, sem criar outro evento.",
    tracks: [
      ["pessoal", "Pessoal"],
      ["empresarial", "Empresarial"],
    ],
    trackNote: {
      pessoal: "Casais, aniversários, formaturas e viagens. Autosserviço até 200 convidados.",
      empresarial:
        "Cerimonialistas, buffets, agências e empresas. Autosserviço até 750 convidados, com nota fiscal.",
    },
    q1: "Que tipo de evento?",
    q2: "Quantos convidados?",
    upTo: "Até {n} convidados",
    over: "Acima de {n} convidados",
    perPerson: " por pessoa",
    freeNote: "Para testar com um grupo pequeno, sem cartão.",
    paidNote:
      "Pagamento único para este evento. Dá para subir de faixa depois pagando só a diferença.",
    contactNote:
      "Nesta trilha, eventos deste tamanho passam pelo nosso time. Chame no WhatsApp e montamos o orçamento.",
    contact: "Fale com a gente",
    free: "Grátis",
    includesLabel: "O que entra",
    includes: {
      free: ["Câmera do evento com cota por pessoa", "Álbum revelado", "Retenção de 30 dias"],
      paid: [
        "Vídeo curto de até 30 s em 1080p",
        "Fotos em qualidade original",
        "Cartão de mesa personalizado",
        "Telão ao vivo",
        "12 meses de acesso, mais 12 só para exportar",
      ],
    },
    everyone:
      "Reações, comentários, moderação, filtro por pessoa e “minhas fotos” valem para todo evento, pago ou não.",
    disclaimer:
      "Valores em reais, a validar. Acima das faixas de autosserviço, montamos o orçamento com você.",
  },
  faq: {
    label: "Perguntas",
    title: "O que perguntam antes de fechar.",
    items: [
      [
        "O convidado precisa instalar alguma coisa?",
        "Não. Ele aponta a câmera para o QR code, o navegador abre e a câmera do evento já está lá. Funciona dentro do WhatsApp e do Instagram.",
      ],
      [
        "Posso revisar as fotos antes de aparecerem?",
        "Pode. A revelação pode ser na hora ou só no fim do evento, e você oculta, exclui ou bane um autor a qualquer momento.",
      ],
      [
        "E se o evento for maior do que a faixa que comprei?",
        "Você sobe de faixa e paga só a diferença. O evento continua o mesmo, com o mesmo QR e o mesmo álbum.",
      ],
      [
        "Dá para entregar com a minha marca?",
        "Sim. Nome, logotipo e cor de destaque são seus, no convite, no álbum e no telão.",
      ],
      [
        "Por quanto tempo as fotos ficam disponíveis?",
        "Em qualquer faixa paga, 12 meses de acesso e mais 12 meses para exportar os arquivos. No plano grátis, 30 dias.",
      ],
      [
        "Funciona com internet ruim?",
        "A câmera é feita para 4G. As fotos entram numa fila e sobem quando a conexão permite, sem travar o convidado.",
      ],
    ],
  },
  foot: {
    cta: "Falar no WhatsApp",
    note: "Respondemos no mesmo dia útil.",
    rights: "2026 Kuori",
  },
};

export default content;
